export default __webpack_public_path__ + "assets/9a8849020c1f1c107a1dd971ae747b83.png";